import { DefaultSeo } from 'next-seo';
import { useTranslations } from 'next-intl';
import useLocalizedSocialsMedia from '@hooks/i18n/useLocalizedSocialsMedia';
import useI18n from '@hooks/i18n/useI18n';

const LocalizedDefaultSeo = () => {
  const tGlobal = useTranslations('Global');
  const tSEODEFAULT = useTranslations('SEO.DEFAULT');
  const { twitter } = useLocalizedSocialsMedia();
  const { locale, domain } = useI18n();

  return (
    <DefaultSeo
      title={tSEODEFAULT('title')}
      openGraph={{
        type: 'website',
        title: tSEODEFAULT('title'),
        images: [
          {
            url: `https://${domain}/images/logo-${locale}.png`,
          },
        ],
        site_name: tGlobal('companyName'),
      }}
      twitter={{
        handle: twitter.handle,
        site: twitter.handle,
        cardType: 'summary_large_image',
      }}
    />
  );
};

export default LocalizedDefaultSeo;
